import * as React from "react"

const Spacer = ({challenges}) => {

  return (
    <div className='challenge--solution p10'>
      <div className='bb1 max-1400 ma'>
      {challenges.map((challenge, index) => {
        return (
          <div key={index} className='grid-1-2 m-block gap-30 bt1 pt40 pb40'>
              <div className='challenge'>
                <p className='m0 pb60 m-p0 text-light'>{challenge.challengeOverline}</p>
                <div className='content text-light max-350 m-mwa m-mt20'>
                  {challenge.challengeTitle}
                </div>
              </div>
              <div className='solution m-mt40'>
                <p className='m0 pb60 m-p0 text-light'>{challenge.solutionOverline}</p>
                <div className='content m-mt20'>
                  {challenge.solutionContent}
                </div>
              </div>
          </div>
        )
      })}
      </div>
    </div> 
  )
} 
export default Spacer
